
const { default: axios } = require('axios');
// If you are using CommonJS modules:
const { Dropzone } = require("dropzone");
// If you are using an older version than Dropzone 6.0.0,
// then you need to disabled the autoDiscover behaviour here:
Dropzone.autoDiscover = false;

let myDropzone = new Dropzone("#banner-management-images-form", {
    url: document.getElementById('banner-management-images-form').getAttribute('action_url'),
    autoProcessQueue: false,
    maxFilesize: 2, // in MB
    acceptedFiles: '.jpg,.jpeg',
    uploadMultiple: true,
    parallelUploads: 15,
    addRemoveLinks: false,
    accept: function (file, done) {

        // Set your desired image dimensions
        var desiredWidth = 1280;  // Example width
        var desiredHeight = 720; // Example height
        // FileReader() asynchronously reads the contents of files (or raw data buffers) stored on the user's computer.
        var reader = new FileReader();
        reader.onload = (function (entry) {
            // The Image() constructor creates a new HTMLImageElement instance.
            var image = new Image();
            image.src = entry.target.result;
            image.onload = function () {

                var width = this.width;
                var height = this.height;

                if (!(width >= desiredWidth && height >= desiredHeight)) {
                    myDropzone.removeFile(file);
                    done("Invalid image dimenssions. Please upload an image with dimensions " + desiredWidth + "x" + desiredHeight + " pixels.");
                }
            };
        });

        reader.readAsDataURL(file);
        done();
    },
    maxFiles: 15,
    init: async function () {
        var myDropzone = this;
        myDropzone.on("processing", function () {
            this.options.autoProcessQueue = false;
        });
        
        var getUrl = document.getElementById('banner-management-images-form').getAttribute('get_files_url');
        // $('#loading_images').show();
        await axios.get(getUrl).then(async (res) => {
            let images = res.data.images;
            await images.map(async (item, index) => {
                var mockFile = {
                    id: item.id,
                    name: item.id,
                    size: item.size,
                    status: Dropzone.ADDED,
                    url: item.image_path
                };

                // Call the default addedfile event handler
                await myDropzone.emit("addedfile", mockFile);

                // And optionally show the thumbnail of the file:
                await myDropzone.emit("thumbnail", mockFile, item.image_path);
                await myDropzone.emit("complete", mockFile);

                await myDropzone.files.push(mockFile);
                await ($('#loading_images').hide());
            });

        }).catch(error => {
            if (error.response) {
                // Server responded with a status other than 200 range
                done(error.response.data.message || "Server error");
            } else if (error.request) {
                // Request was made but no response received
                done("Network error");
            } else {
                // Something else caused the error
                done(error.message);
            }
        })

        myDropzone.on("sending", function (file) {
            // Show the total progress bar when uploading starts                 
            $('#progress-indicator-label').text('Uploading images ...');                       
        });

    },
    dictDefaultMessage: `<div class="relative flex items-center justify-center w-full h-64">
            <!-- Removed ID from label -->
            <label class="flex flex-col items-center justify-center w-full h-full border-2 border-gray-300 border-dashed cursor-pointer bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                <div class="flex flex-col items-center justify-center pt-5 pb-6">
                    <svg class="mb-4 text-gray-500 w-14 h-14 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                    </svg>
                    <p class="mb-2 text-sm text-gray-500 dark:text-gray-400">
                        <span class="text-2xl font-semibold">Click to upload or drop files here</span>
                    </p>
                    <p class="px-8 text-center text-red-300 dark:text-gray-400">
                        <ul class="list-disc">
                            <li class="text-xs text-red-300">Minimum 5 or maximum 15 images</li>
                            <li class="text-xs text-red-300">JPEG or JPG format only</li>
                            <li class="text-xs text-red-300">Minimum resolution: 1280x720 px</li>
                            <li class="text-xs text-red-300">Maximum image size: 2MB each</li>
                        </ul>
                    </p>
                </div>
            </label>
        </div>`,
    previewTemplate: `<div class="dz-preview dz-error dz-complete dz-image-preview">
        <div class="dz-image"><img data-dz-thumbnail=""  class="w-40 h-40"></div>
        <div class="dz-details">
        <div class="dz-size"><span data-dz-size=""><strong>10.1</strong> MB</span></div>
    </div>
        <div class="dz-progress"> <span class="dz-upload" data-dz-uploadprogress=""></span> </div>
        <div class="dz-error-message"><span data-dz-errormessage=""></span></div>
        <a href="#" class="dz-remove" data-dz-remove><i class="fa fa-times"></i></a>
    </div>`,
    previewsContainer: '#preview',
    dictFallbackMessage: "Your browser does not support drag and drop file uploads.",
    dictFileTooBig: "File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
    dictInvalidFileType: "Invalid file type.",
    dictResponseError: "Server responded with {{statusCode}} code.",
    dictCancelUpload: "Cancel upload",
    dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
    dictRemoveFile: "Remove file",
    dictMaxFilesExceeded: "Max files exceeded.",
});
myDropzone.on("addedfile", file => {
    if (myDropzone.files.length > myDropzone.options.maxFiles) {
        myDropzone.removeFile(file);
        myDropzone.emit("maxfilesexceeded", file);
    }

    if (!file?.id) {
        totalImage('add');
    }
});
myDropzone.on("maxfilesexceeded", function (file) {
    var message = "No more files can be added.";
    $('#error_projects_images').text(message).addClass('text-red-400 py-4');
});
myDropzone.on("error", function (file, message) {
    if (message?.errors?.file) {
        message = message.errors.file.toString();
    }
    myDropzone.removeFile(file);
    totalImage();
    $('#error_projects_images').text(message).addClass('text-red-400 py-4');
});
var deletedImage = [];
myDropzone.on("removedfile", file => {
    deletedImage.push(file.id);
    totalImage('remove');
    $('#deleted_images').val(deletedImage.join(','));
})

function totalImage() {
    $('#photos').text(myDropzone.files.length);
}

$.validator.addMethod("slugFormat", function(value, element) {
    return this.optional(element) || /^[a-z0-9-_]+$/.test(value);
}, "The slug can only contain lowercase letters, numbers, and hyphens.");

if ($('#banners-management-form').length) {
    $('#banners-management-form').validate({
        rules: {                                                
            developer_id: {
                required: true
            },
            slug: {
                required: true,                
                slugFormat: true,
            }, 
            image_path: {
                required: function (){
                    return $('#image_path_preview').length === 0 ;            
                    
                }
            },                   
            mobile_image_path: {
                required: function (){
                    return $('#mobile_image_path_preview').length === 0 ;            
                    
                }
            }                       
        },
        messages: {                        
            image_path: {
                required: 'This field is required',
            },
            mobile_image_path: {
                required: 'This field is required',
            },
            developer_id: {
                required: 'This field is required',
            },
            slug: {
                required: 'This field is required',                
            },            
        },
        errorPlacement: function (error, element) {                   
            
            if (element.attr("name") == 'developer_id' ) {                             
                $("#developer_id-ui-error").text('This field is required.');
            }  
            else if (element.attr("name") == 'slug') {                
                $("#slug-ui-error").text('The slug is required and can only contain lowercase letters, numbers, and hyphens.');                
            }                                     
            else if (element.attr("name") == 'image_path') {                
                $("#image_path-ui-error").text('This field is required.');                
            }                                     
            else if (element.attr("name") == 'mobile_image_path') {                
                $("#mobile_image_path-ui-error").text('This field is required.');                
            }                                     
        },
        highlight: function(element, errorClass) {
            // Override highlight function to prevent adding errorClass to input field
            $(element).removeClass(errorClass);
          },
          unhighlight: function(element, errorClass) {
            // Override unhighlight function as well
            $(element).next(".error").text('');
            
         },
        submitHandler: async (form) => {
            event.preventDefault();
            if (myDropzone.files.length > myDropzone.options.maxFiles) {
                $('#photos_error').text('Maximuim 15 images')
                return;
            }
            if (myDropzone.files.length < 3 && myDropzone.files.length > 0) {
                $('#photos_error').text('Minimum 3 images required')
                return;
            }                   
            
            await saveData();            

            async function saveData() {
                var data = new FormData($('#banners-management-form')[0]);    

                //show progress indicators
                document.querySelector('#SaveButton').setAttribute('disabled');
                $('#progress-indicator').removeClass('hidden');
                $('#progress-indicator-label').text('Saving data ...');

                $('#photos_error').text('');//reset photos error now

                await axios.post($(form).attr('action'), data, {
                    headers: {
                      'accept': 'application/json',
                      'Accept-Language': 'en-US,en;q=0.8',
                      'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
                    }
                }).then((res) => {                    

                    if(res.data && res.data.banner_id !== undefined && res.data.banner_id > 0){
                        let bannerId = res.data.banner_id;
                        let uploadUrl = myDropzone.options.url;
                        let newUploadUrl = uploadUrl.replace(/\/\d+$/, `/${bannerId}`);//if it is add banner management then replace 0 with banner_id 
                        myDropzone.options.url = newUploadUrl;                    

                        if (myDropzone.getQueuedFiles().length > 0) {
                            myDropzone.processQueue(); // Manually start the upload process              

                            
                            myDropzone.on("successmultiple", async () => {                                                                                                                                
                                
                                $('#progress-indicator-label').text('Images uploaded ...');   
                                setTimeout(() => {                                                                     
                                    //redirect to banner list page now
                                    Livewire.emit('alert', { 'message': res.data.message, 'type': 'success', 'html': false }); 
                                    document.querySelector('#SaveButton').removeAttribute('disabled');
                                    $('#progress-indicator').addClass('hidden');                            
                                    window.location.href = $('#CancelButton').prop('href');                                    
                                }, 300);                                
                            });
                        }else{
                            Livewire.emit('alert', { 'message': res.data.message, 'type': 'success', 'html': false }); 
                            document.querySelector('#SaveButton').removeAttribute('disabled');
                            $('#progress-indicator').addClass('hidden');                            
                            window.location.href = $('#CancelButton').prop('href');                            
                        }
                        
                    }
                }).catch(error => {          
                    
                    $('#progress-indicator').addClass('hidden');
                    document.querySelector('#SaveButton').removeAttribute('disabled');

                    if (error.response && error.response.status === 422) {
                        // Access the validation errors from the response
                        const validationErrors = error.response.data.errors;                        
                        
                        if (validationErrors.label) {
                            $("#label-ui-error").text(validationErrors.label[0]);
                        }
                        
                        if (validationErrors.developer_id ) {
                            $("#developer_id-ui-error").text(validationErrors.developer_id[0]);
                        }

                        if (validationErrors.image_path) {
                            $("#image_path-ui-error").text(validationErrors.image_path[0]);                            
                        }
                        
                        if (validationErrors.mobile_image_path) {
                            $("#mobile_image_path-ui-error").text(validationErrors.mobile_image_path[0]);                            
                        }
                        if (validationErrors.new_launch_image) {
                            $("#new_launch_image-ui-error").text(validationErrors.new_launch_image[0]);                            
                        }

                        if (validationErrors.banner_duration) {
                            $("#banner_duration_error").text(validationErrors.banner_duration[0]);
                        }

                        if (validationErrors.slug) {
                            $("#slug-ui-error").text(validationErrors.slug[0]);
                        }                        
                        
                    } else {
                        //console.log(error);
                        Livewire.emit('alert', { 'message': 'Failed to save', 'type': 'error', 'html': false });
                    }
                })
            }
            return false;
        }
    });
}


